import * as Clipboard from 'expo-clipboard';
import { Alert, Platform } from 'react-native';

/**
 * Copy text to the system clipboard. Uses expo-clipboard instead of
 * @react-native-clipboard/clipboard to avoid NativeEventEmitter / RNCClipboard
 * crashes during module initialization on some iOS builds.
 */
export async function copyToClipboard(text: string): Promise<void> {
  try {
    await Clipboard.setStringAsync(text);
  } catch {
    if (Platform.OS === 'web' && typeof navigator !== 'undefined' && navigator.clipboard) {
      await navigator.clipboard.writeText(text).catch(() => {
        Alert.alert('Copy failed', 'Unable to copy to clipboard.');
      });
    } else {
      Alert.alert('Copy to Clipboard', text, [{ text: 'OK' }]);
    }
  }
}
